import React from 'react';
import { FormattedMessage } from 'react-intl';
import Rocket from '../assets/rocket.svg';
import Help from '../assets/help.svg';
import Idea from '../assets/idea.svg';
import Update from '../assets/update.svg';
import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 50px;

  ${breakpoint('tablet')`
    flex-direction: row;
    width: calc(100vw - 40px);
    max-width: 1000px;
    margin-bottom: 60px;
    `};
`;

const CardWrapper = styled.div`
  height: 162px;
  width: 250px;
  background-color: #ffffff;
  box-shadow: 0 2px 39px 0 rgba(0, 0, 0, 0.03);
  border-bottom: 1px solid #fdba29;
  text-align: center;
  padding: 30px 30px 0 30px;
  box-sizing: border-box;
  margin-bottom: 30px;

  &:last-of-type {
    margin-bottom: 0;
  }

  ${breakpoint('tablet')`
    width: 200px;
    margin-bottom: 0;
    margin-right: 67px;

    &:last-of-type{
        margin-right: 0;
    }
  `};
`;

const Image = styled.img`
  margin-bottom: 25px;
`;

const P = styled.p`
  font-size: 15px;
  line-height: 17px;
`;

const Card = ({ image, text }) => {
  return (
    <CardWrapper>
      <Image src={image} alt="" />
      <P>{text}</P>
    </CardWrapper>
  );
};

const CardsBlock = () => {
  return (
    <Wrapper>
      <Card
        image={Rocket}
        text={
          <FormattedMessage
            id="shop.block.cards.first"
            defaultMessage="Быстрый запуск"
          />
        }
      />
      <Card
        image={Help}
        text={
          <FormattedMessage
            id="shop.block.cards.second"
            defaultMessage="Поддержка сайта 24/7"
          />
        }
      />
      <Card
        image={Update}
        text={
          <FormattedMessage
            id="shop.block.cards.third"
            defaultMessage="Регулярные обновления"
          />
        }
      />
      <Card
        image={Idea}
        text={
          <FormattedMessage
            id="shop.block.cards.fourth"
            defaultMessage="Помощь в интеграции данных"
          />
        }
      />
    </Wrapper>
  );
};

export default CardsBlock;
